import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { useDispatch } from 'react-redux';

export const Login = () => {

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  const handleLogin = () => {
    if (!email || !password) {
      setError("Email and password are required");
      return;
    }
    fetch('/apilogin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ email, password })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(data => { throw new Error(data.message || 'Login failed'); });
      }
      return response.json();
    })
    .then(user => {
      dispatch({ type: 'LOG_IN', payload: user });
      fetch('/apivendor', { credentials: 'include' })
        .then(res => res.ok ? res.json() : null)
        .then(client => {
          if (client) dispatch({ type: 'SET_CLIENT', payload: client });
        });
      navigate("/");
    })
    .catch(err => {
      setError(err.message);
    });
  }

  const handleChangeInput = (e, callback) => {
    setError("");
    callback(e.target.value);
  }

  return (
    <div className="loginPage">
      <div className="loginLeft">
        <div className="loginFormWrapper">
          <img className="fusaLogoLogin" src="https://res.cloudinary.com/dof3z7iuh/image/upload/v1770844655/Guard_Services___NEW_Logo_RGB-02_1_jmqeji.png" alt="GSUSA Logo" />
          <h1 className="loginTitle">Login</h1>
          <div className="signupInputsWrapper">
            <input placeholder="Email or username..." className="inputAuth" onChange={(e) => handleChangeInput(e, setEmail)} />
            <input placeholder="Password..." type="password" className="inputAuth" onChange={(e) => handleChangeInput(e, setPassword)} />
            {error && <p style={{ color: '#e74c3c', fontSize: '14px', margin: '8px 0 0' }}>{error}</p>}
            <button className="mainButton loginButton" onClick={handleLogin}>Login</button>
          </div>
        </div>
      </div>
      <div className="loginRight">
        <img className="loginHeroImage" src="https://res.cloudinary.com/dof3z7iuh/image/upload/q_auto/f_auto/v1775159590/gsusa_portal_homepage_image_ebmifv.jpg" alt="GSUSA" />
      </div>
    </div>
  )
}
